export default __webpack_public_path__ + "images/tech-design-installation-service.jpg";